import React, { useEffect, useState, useContext } from "react";
import TransferLocations from "./TransferLocations";
import { UserContext } from "../UserContext";
import api from "../api/index"; 

function TransfersPage() {
  const [transfers, setTransfers] = useState([]);
  const { user } = useContext(UserContext);

  const fetchTransfers = async () => {
    const res = await fetch(
      `${api.main}api/agent/transfers?sagent_id=${encodeURIComponent(
        user.id
      )}&access_token=${user.access_token}`
    );
    const data = await res.json();

    const rawTransfers = data.transfers || [];

    const formattedTransfers = rawTransfers.map((t) => {
      const line1 = t.address || "";
      const line2Parts = [
        t.city,
        t.state && t.zipcode ? `${t.state} ${t.zipcode}` : transfers.state || "",
        t.country,
      ].filter(Boolean);

      const line2 = line2Parts.join(", ");
      const fullAddress = [line1, line2].filter(Boolean).join(", ");

      return {
        ...t,
        // top-level convenience field
        address_display: fullAddress,
        // also decorate nested location if present
        location: t.location
          ? { ...t.location, address_display: fullAddress }
          : t.location,
      };
    });

    setTransfers(formattedTransfers);
  };

  useEffect(() => {
    fetchTransfers();
  }, []);

  return (
    <div>
      <TransferLocations
        transfers={transfers}
        sagent_id={encodeURIComponent(user.id)}
        accessToken={user.access_token}
        onTransfersUpdated={fetchTransfers}
      />
    </div>
  );
}

export default TransfersPage;